<template>
  <div>
    <div>
      <div class="titlePdf text-center html2pdf__page-break">
        <p
          class="font-size-36 text-dark font-weight-semibold"
          style="font-size: 36px"
        >
          判定結果
        </p>
        <div
          style="
            text-align: left;
            font-size: 18px;
            color: black;
            margin-top: 400px;
            margin-left: -132px;
          "
        >
          <p>
            名前 :
            {{
              infoPDF && infoPDF.information ? infoPDF.information.fullname : ""
            }}
          </p>
          <p>ID : {{ infoPDF.patient_id }}</p>

          <p>
            性別 :
            {{
              infoPDF.information && infoPDF.information.sex === 0
                ? "女性"
                : infoPDF.information && infoPDF.information.sex === 1
                ? "男性"
                : "無回答"
            }}
          </p>
          <p>質問 ：身体状態</p>
        </div>
      </div>
    </div>

    <div
      class="row justify-content-center"
      style="color: black !important; font-size: 13px"
    >
      <div class="col-9" style="margin-left: -65px">
        <table>
          <tbody>
            <tr
              v-for="(medical, index) in dataPdf"
              :key="index"
              class="html2pdf__page-break break-page"
            >
              <td class="px-3 py-4 w-25" style="padding: 0 !important">
                <p
                  class="text-list-time"
                  style="
                    margin-top: 28px;
                    margin-bottom: 15px;
                    font-size: 14px;
                    color: black !important;
                  "
                >
                  {{ medical.created_at | fomatDate2 }}
                </p>
                <div class="row pt-2">
                  <div class="col-md-6">
                    <div class="mt-4">
                      <div>身長</div>
                      <div>➝ {{ medical.height ? medical.height + '（cm ）': "" }}</div>
                    </div>
                    <div class="mt-4">
                      <div>体重</div>
                      ➝{{ medical.weight ? medical.weight + '（kg ）': "" }}
                    </div>
                    <div class="mt-4">
                      <div>BMI</div>
                      <div>
                        ➝
                        {{ calculateBmi(medical.weight, medical.height) }}
                      </div>
                    </div>
                    <div class="mt-4">
                      <div>肥満の判定</div>
                      <div>➝ {{ desBmi(medical.weight, medical.height) }}</div>
                    </div>
                    <div>
                      <div class="mt-4">血圧</div>
                      ➝{{ medical.blood_pressure ? medical.blood_pressure + '（mmhg ）': "回答なし" }}
                    </div>
                    <div>
                      <div class="mt-4">脈拍</div>
                      ➝{{ medical.pulsation ? medical.pulsation + '（bpm ）': "回答なし" }}
                    </div>
                    <div class="mt-4">
                      <div>症状</div>
                      <div>
                        ➝ {{ medical.symptom ? medical.symptom : "回答なし" }}
                      </div>
                    </div>
                    <div>
                      <div class="mt-4">症状はいつから?</div>
                      <div>➝ {{ medical.when ? medical.when : "回答なし" }}</div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div>
                      <div class="mt-4">動悸・胸の痛み</div>
                      <div>➝ {{ medical.palpitation ? "ある" : "ない" }}</div>
                    </div>
                    <div>
                      <div class="mt-4">特記項目</div>
                      <div>
                        ➝ {{ medical.special ? medical.special : "回答なし" }}
                      </div>
                    </div>
                    <div>
                      <div class="mt-4">指摘・治療中の病気</div>
                      <div>
                        ➝ {{ medical.diseases ? medical.diseases : "回答なし" }}
                      </div>
                    </div>
                    <div>
                      <div class="mt-4">過去の病歴</div>
                      <div>
                        ➝
                        {{
                          medical.past_medical_history
                            ? medical.past_medical_history
                            : "回答なし"
                        }}
                      </div>
                    </div>
                    <div>
                      <div class="mt-4">家族親族の病気</div>
                      <div>
                        ➝
                        {{
                          medical.family_relative
                            ? medical.family_relative
                            : "回答なし"
                        }}
                      </div>
                    </div>
                    <div>
                      <div class="mt-4">現在、飲んでいるお薬</div>
                      <div>
                        ➝
                        {{
                          medical.medication_taking
                            ? medical.medication_taking
                            : "回答なし"
                        }}
                      </div>
                    </div>
                    <div>
                      <div class="mt-4">喫煙</div>
                      <div>
                        ➝
                        {{
                          medical.smoking
                            ? medical.smoking + "本 / 1日"
                            : "回答なし"
                        }}
                      </div>
                    </div>
                    <div>
                      <div class="mt-4">飲酒</div>
                      <div class="mb-4">
                        ➝
                        {{
                          medical.drinking
                            ? medical.drinking + "合/ 1日"
                            : "回答なし"
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { filter } from "../../helpers/Vue-Filter";
import { hospitalMethods } from "@/state/helpers";
import { hospitalComputed } from "@/state/helpers";
import { userMethods, userComputed } from "@/state/helpers";
import {getProfile} from "../../helpers/Auth";

export default {
  filters: {
    ...filter,
  },

  props: ["infoPDF", "dataPdf"],

  components: {},
  data() {
    return {
      clickIndex: 0,
      loaderDetail: false,
      uuidArr: [],
      role: getProfile().role.name,
      edit: false,
      dataEdit: [],

    };
  },


  created() {},

  computed: {
    ...hospitalComputed,
    ...userComputed,
  },

  methods: {
    ...hospitalMethods,
    ...userMethods,
    desBmi(weight, height){ 
      const bmi = this.calculateBmi(weight, height)
      if (bmi < 18.5) {
        return ("低体重(痩せ型)");
      } else if (bmi >= 18.5 && bmi < 25) {
        return ("普通体重");
      } else if (bmi >= 25 && bmi < 30) {
        return ("肥満（１度）");
      } else if (bmi >= 30 && bmi < 35) {
        return ("肥満（２度）");
      } else if (bmi >= 35 && bmi < 40) {
        return ("肥満（３度）");
      } else {
        return ("肥満（４度）");
      }
    },

    calculateBmi (weight, height){
      if(weight && height && weight > 0 && height > 0){
        const bmi = ( parseFloat(weight) / parseFloat((height * height) /10000 ) ).toFixed(2);
        return bmi
      } else {
        return 0;
      }
    },

    
  },
};
</script>

<style lang="scss" scoped>
.text-list-locomo-7 {
  color: #1d1d1d;
  font-size: 16px;
  font-weight: 700;
}

.undefine {
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #404040;
}

.titlePdf {
  margin: auto;
  width: 50%;
  padding: 10px;
  //   height: 100px !important;
  margin-top: 50%;
}

.text-list-time {
  color: #404040;
  font-weight: 400;
  font-size: 14px;
}

* {
  font-family: "Noto Sans JP";
}
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

::-webkit-input-placeholder {
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

.text-table {
  color: #404040;
}

.text-link {
  color: #336aff;
}

.bg-active-locomo {
  background: #f8f9fa;
}

.text-color {
  color: #1d1d1d;
}

.text-end {
  align-items: end;
}

.btn-edit {
  color: white;
  background-color: #8fc31f;
  border: none;
  border-radius: 4px;
  padding: 5px;
  margin-left: 24px;
}

.btn-cancel {
  color: #ff5858;
  background-color: white;
  border: 1px solid #ff5858;
  border-radius: 4px;
  padding: 5px;
}

.w-70 {
  width: 70%;
}

.require {
  background: #ff5858;
  border-radius: 14px;
  color: #f5f5f5;
  padding: 0 7px;
  font-weight: 400;
}

.card-title {
  color: #404040;
}

.text-muted {
  color: #828282 !important;
}

.undefine {
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #404040;
}

.scroll {
  max-height: 50vh;
  overflow-y: scroll;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.info {
  text-align: left;
  font-size: 18px;
  color: black;
  margin-top: 400px;
  margin-left: -100px;
}
.font-size-36 {
  font-size: 36px;
}
</style>
